import { useStore } from 'zustand/react';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Composite selector for LabelValueCell
 * Combines multiple store selections into one to reduce re-renders
 * and prevent unnecessary component updates
 */
export const useLabelValueCellStore = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      isEditMode: state.isEditMode,
      timePeriod: state.timePeriod,
      setDuplicationDateSelection: state.setDuplicationDateSelection,
    }))
  );
};
